import * as React from 'react';
import classnames from 'classnames';
import { Alert, SummaryContainer, Button } from '@grandvisionhq/common';
import { Hr } from '@grandvisionhq/elements';
import { statusLoading, statusIdle, statusFailed, statusSuccess } from '@grandvisionhq/state';
import SubscriptionHeader from '../../components/SubscriptionHeader/SubscriptionHeader.js';
import SubscriptionLineItem from '../../components/SubscriptionLineItem/SubscriptionLineItem.js';
import SubscriptionLineItemFailed from '../../components/SubscriptionLineItem/SubscriptionLineItemFailed.js';
import SubscriptionLineItemLoader from '../../components/SubscriptionLineItem/SubscriptionLineItemLoader.js';
import ChangeQuantityModal from './Modals/ChangeQuantity/ChangeQuantity.js';
import PauseSubscriptionModal from './Modals/PauseSubscription/PauseSubscription.js';

class CurrentPlan extends React.Component {
    componentDidUpdate(prevProps, prevState) {
        // Close modal if pause or quantity call went from loading to idle
        if (statusLoading(prevProps.pauseCall) && statusIdle(this.props.pauseCall) || statusLoading(prevProps.quantityCall) && statusIdle(this.props.quantityCall)) {
            this.closeModal();
        }
        // Pause error
        if (statusLoading(prevProps.pauseCall) && statusFailed(this.props.pauseCall)) {
            this.setState({
                pauseError: this.props.intl.getFormattedLabel('account.subscription.pause.error', {
                    parseLink: true
                })
            });
        }
        if (statusFailed(prevProps.pauseCall) && prevState.activeModal && !this.state.activeModal) {
            this.setState({
                pauseError: undefined
            });
        }
        // Quantity error
        if (statusLoading(prevProps.quantityCall) && statusFailed(this.props.quantityCall)) {
            this.setState({
                quantityError: this.props.intl.getFormattedLabel('account.subscription.quantity.error', {
                    parseLink: true
                })
            });
        }
        if (statusFailed(prevProps.quantityCall) && prevState.activeModal && !this.state.activeModal) {
            this.setState({
                quantityError: undefined
            });
        }
    }
    render() {
        const { subscription , className , intl , productData , pauseCall , quantityCall , handleTopUp , reorderLoading , getEyeSide ,  } = this.props;
        const nextDelivery = subscription.deliveries.find((d)=>d.status !== 'DELIVERED'
        );
        const price = subscription.billing.totalPricePerInstallment;
        const hasQuantityPending = subscription.pendingChanges.includes('quantity');
        const hasPausePending = subscription.pendingChanges.includes('pause');
        const isSubscriptionDisabled = [
            'EXPIRED',
            'CANCELLED',
            'ON_HOLD'
        ].some((s)=>s === subscription.status
        );
        const renderLineItem = (lineItem)=>{
            const data = productData[lineItem.productId];
            const { eyeSide  } = getEyeSide(lineItem.application);
            if (!data || statusLoading(data)) {
                return /*#__PURE__*/ React.createElement(SubscriptionLineItemLoader, null);
            }
            if (statusFailed(data)) {
                return /*#__PURE__*/ React.createElement(SubscriptionLineItemFailed, null);
            }
            if (statusSuccess(data)) {
                return /*#__PURE__*/ React.createElement(SubscriptionLineItem, {
                    product: data.result,
                    quantity: lineItem.quantity,
                    eyeSide: eyeSide
                });
            }
        };
        const reorderWarning = intl.getLabel('account.subscription.topUp.description', {
            hideLabelKey: true
        });
        return /*#__PURE__*/ React.createElement("section", {
            className: classnames('current-plan', className)
        }, renderStatusAlert(subscription.status, intl), renderPendingChangesAlert(subscription.pendingChanges, intl), /*#__PURE__*/ React.createElement(SubscriptionHeader, {
            nextDelivery: nextDelivery,
            expiryDate: subscription.expiryDate,
            totalPrice: price,
            status: subscription.status,
            disabled: isSubscriptionDisabled,
            className: classnames('current-plan__summary'),
            deliveryFrequency: subscription.deliveryFrequency
        }), /*#__PURE__*/ React.createElement(SummaryContainer, {
            className: "current-plan__summary"
        }, subscription.lineItems.map((lineItem, index)=>/*#__PURE__*/ React.createElement(React.Fragment, {
                key: `${lineItem.productId}-${index}`
            }, !!index && /*#__PURE__*/ React.createElement(Hr, null), renderLineItem(lineItem))
        )), subscription.topUpAllowed && reorderWarning && /*#__PURE__*/ React.createElement(Alert, {
            "data-t": "top-up-description",
            className: "current-plan__topup-description",
            message: reorderWarning
        }), /*#__PURE__*/ React.createElement("div", {
            className: "current-plan__buttons"
        }, subscription.topUpAllowed && /*#__PURE__*/ React.createElement(Button, {
            "data-t": "top-up",
            className: "current-plan__button",
            caption: intl.getLabel('account.subscription.action.topUp'),
            onClick: reorderLoading ? undefined : handleTopUp,
            isLoading: reorderLoading,
            disabled: isSubscriptionDisabled
        }), /*#__PURE__*/ React.createElement(Button, {
            "data-t": "edit-subscription",
            btnRef: this.editButtonRef,
            className: "current-plan__button",
            caption: intl.getLabel('account.subscription.action.edit'),
            onClick: this.openQuantityModal,
            variant: "outline",
            disabled: !subscription.quantityChangeable || hasQuantityPending || isSubscriptionDisabled
        })), /*#__PURE__*/ React.createElement(Hr, null), subscription.pauseOptions.length === 0 && /*#__PURE__*/ React.createElement(Alert, {
            type: "info",
            message: intl.getFormattedLabel('account.subscription.pause.noBudget', {
                parseLink: true
            })
        }), /*#__PURE__*/ React.createElement(Button, {
            "data-t": "pause-subscription",
            className: "current-plan__pause-button",
            caption: intl.getLabel('account.subscription.action.pause'),
            onClick: this.openPauseModal,
            btnRef: this.pauseButtonRef,
            variant: "outline",
            disabled: subscription.pauseOptions.length === 0 || hasPausePending || isSubscriptionDisabled
        }), this.state.activeModal === 'pause' && subscription.pauseOptions.length > 0 && /*#__PURE__*/ React.createElement(PauseSubscriptionModal, {
            onCancel: this.closeModal,
            pauseDurationOptions: subscription.pauseOptions,
            onPause: this.handlePause,
            isLoading: statusLoading(pauseCall),
            errorMessage: this.state.pauseError
        }), this.state.activeModal === 'quantity' && /*#__PURE__*/ React.createElement(ChangeQuantityModal, {
            onCancel: this.closeModal,
            maxQuantity: 3,
            onEditQuantity: this.handleEdit,
            isLoading: statusLoading(quantityCall),
            errorMessage: this.state.quantityError,
            totalPricePerInstallment: subscription.billing.totalPricePerInstallment
        }));
    }
    constructor(...args){
        super(...args);
        this.pauseButtonRef = /*#__PURE__*/ React.createRef();
        this.editButtonRef = /*#__PURE__*/ React.createRef();
        this.state = {
            activeModal: undefined
        };
        this.openQuantityModal = ()=>{
            this.setState({
                activeModal: 'quantity'
            });
        };
        this.openPauseModal = ()=>{
            this.setState({
                activeModal: 'pause'
            });
        };
        this.focusModalTrigger = (focusRef)=>{
            focusRef.current && focusRef.current.focus();
        };
        this.closeModal = ()=>{
            const focusRef = this.state.activeModal === 'pause' ? this.pauseButtonRef : this.editButtonRef;
            this.setState({
                activeModal: undefined
            });
            this.focusModalTrigger(focusRef);
        };
        this.handlePause = (duration)=>{
            this.props.pause(duration);
        };
        this.handleEdit = (quantity)=>{
            this.props.quantity({
                quantity
            });
        };
    }
}
function renderPendingChangesAlert(pendingChanges, intl) {
    if (pendingChanges.length < 1) {
        return;
    }
    if (pendingChanges.length > 1) {
        return /*#__PURE__*/ React.createElement(Alert, {
            key: "multiple",
            type: "info",
            message: intl.getFormattedLabel(`account.subscription.pauseAndQuantity.processing`, {
                parseLink: true
            })
        });
    }
    const type = pendingChanges[0];
    return /*#__PURE__*/ React.createElement(Alert, {
        key: type,
        type: "info",
        message: intl.getFormattedLabel(`account.subscription.${type}.processing`, {
            parseLink: true
        })
    });
}
function renderStatusAlert(status, intl) {
    let message;
    switch(status){
        case 'CANCELLED':
        case 'EXPIRED':
        case 'PAUSED':
            message = intl.getFormattedLabel(`account.subscription.${status.toLowerCase()}`, {
                parseLink: true
            });
            break;
        case 'PENDING':
        case 'ACTIVE':
            break;
        case 'ON_HOLD':
            message = intl.getFormattedLabel(`account.subscription.onHold`, {
                parseLink: true
            });
            break;
    }
    return message && /*#__PURE__*/ React.createElement(Alert, {
        type: "error",
        notifyScreenReader: false,
        message: message
    });
}

export { CurrentPlan };
//# sourceMappingURL=CurrentPlan.js.map
